(() => {
  const selector = 'facet-remove-component[data-url]';

  const getUrl = (el) => el?.getAttribute('data-url');

  const findFacet = (target) => target?.closest?.(selector);

  const navigate = (url) => {
    if (!url) return;
    window.location.href = url;
  };

  const handleClick = (event) => {
    const facet = findFacet(event.target);
    if (!facet) return;

    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) {
      event.stopImmediatePropagation();
    }

    navigate(getUrl(facet));
  };

  const handleKeydown = (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;

    const facet = findFacet(event.target);
    if (!facet) return;

    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) {
      event.stopImmediatePropagation();
    }

    navigate(getUrl(facet));
  };

  document.addEventListener('click', handleClick, true);
  document.addEventListener('keydown', handleKeydown, true);
})();